const AD_ID_RE = /^Ad ID:\s*(\d{6,25})\s*$/m;
const LINK_RE = /^\[[^\]]*\]\((https?:\/\/[^)]+)\)\s*$/m;
// Dòng tiêu đề, mã, ref và link cuối không thuộc nội dung bài.
const CHROME_RE = /^(📣|Ad ID:|ref:|\[[^\]]*\]\(https?:\/\/[^)]+\)\s*$)/;

/**
 * Đọc ngược thẻ quảng cáo từ markdown của ghi chú.
 *
 * Chỉ phục vụ ghi chú tạo TRƯỚC khi `AdsReferralService` gắn `bonboz_ad` vào
 * `content_attributes`. Ghi chú mới đi đường có cấu trúc, không qua đây.
 */
export function parseAdNote(content) {
  const text = content ?? '';

  return {
    adId: text.match(AD_ID_RE)?.[1],
    permalinkUrl: text.match(LINK_RE)?.[1],
    body: text
      .split('\n')
      .filter(line => !CHROME_RE.test(line))
      .join('\n')
      .trim(),
  };
}
